// Ask the browser's password manager to save (or update) the login.
// Chrome/Edge/Android support the Credential Management API and show their
// "Save password?" prompt right away. Safari and Firefox don't, but they still
// offer to save because the forms use standard autocomplete attributes.
export const offerToSavePassword = async ({ email, password, name }) => {
  if (!email || !password) return;
  if (typeof window === 'undefined' || !window.PasswordCredential || !navigator.credentials?.store) return;
  try {
    const credential = new window.PasswordCredential({ id: email, password, name: name || email });
    await navigator.credentials.store(credential);
  } catch {
    // The user dismissed the prompt or the browser blocked it — nothing to do.
  }
};
